import axios from "axios"
import {error, info} from '../util/alert'
import {storageKeys} from '../util/storage'
import {decodeJWT} from "../util/Util";
import {evalError, getConfig} from "./utility";
import * as auth from '../auth/authentication';


const initialState = {
    loggedIn: false,
    email: null,
    firstname: null,
    lastname: null,
    loading: false,
    isAdmin: false,
    exp: null,
};

const RESET = 'RESET';
const SENDING_REQUEST = 'SENDING_REQUEST';
const SET_CLAIMS = 'SET_CLAIMS';
const SET_TOKEN = 'SET_TOKEN';
const SET_AUTH = 'SET_AUTH';

export default (state = initialState, action) => {
    switch (action.type) {
        case 'AUTH_LOGIN':
            switch (action.status) {
                case 0:
                    return {...state, loading: true};
                case 1:
                    const claims = decodeJWT(action.token);
                    return {
                        ...state,
                        loading: false,
                        email: action.email,
                        firstname: claims.firstname,
                        lastname: claims.lastname,
                        isAdmin: claims.isAdmin,
                        loggedIn: true,
                    };
                default:
                    error(action.error);
                    return {...state, loading: false};

            }
        case SENDING_REQUEST:
            return {...state, currentlySending: action.sending};
        case SET_TOKEN:
            const {token, rememberMe} = action;
            if (rememberMe) localStorage[storageKeys.TOKEN] = token;
            return {...state, token};
        case SET_AUTH:
            console.log('setting logged in:', action.newState);
            return {...state, loggedIn: action.newState};
        case SET_CLAIMS:
            const {email, exp, firstname, lastname,isAdmin} = action.claims || {};
            return {
                ...state,
                exp: new Date(exp * 1000),
                email,
                firstname,
                lastname,
                isAdmin
            };
        default:
            return state
    }
}

export const init = () => (dispatch, getState) => {
    const token = localStorage[storageKeys.TOKEN];
    if (token && token.indexOf(".") > 0) {
        const claims = decodeJWT(token);
        dispatch(setClaims(claims));
        dispatch(setToken(token));
        dispatch(setAuthState(true));
        const hasValidToken = checkAuth(dispatch, getState);
        if (hasValidToken) {
            refreshToken(dispatch, getState)
        }
    }
};

/**
 * Logs an user in
 * @param  {string} email The name of the userId to be logged in
 * @param  {string} password The password of the userId to be logged in
 * @param  {bool}   rememberMe Whether the userId should be remembered in localStorage
 */
export const login = ({email, password, rememberMe}) => dispatch => {
    dispatch(sendingRequest(true));
    return auth.login(email, password)
        .then(({token, claims}) => {
            localStorage[storageKeys.EMAIL] = email;
            localStorage[storageKeys.TOKEN] = token;
            dispatch(setClaims(claims));
            dispatch(setToken(token, rememberMe));

        })
        .catch(evalError(dispatch, null))
        .then(errRes => {
            dispatch(sendingRequest(false));
            dispatch(setAuthState(errRes !== null))
        });
};


export const logout = () => dispatch => {
    delete localStorage[storageKeys.TOKEN];
    delete localStorage[storageKeys.EMAIL];
    dispatch(setAuthState(false));
    dispatch(setClaims(null, null));
    dispatch({type: RESET});
};


export const checkAuth = (dispatch, getState) => {
    const exp = getState().auth.exp;
    if (exp && new Date() > exp) {
        info("Your access token has expired, please log in again");
        dispatch(logout());
        return false
    }
    return true
};

/**
 * Regularly refresh the token to prevent preemptive logout
 */
const refreshToken = (dispatch, getState) => {
    axios.get('/auth/refresh', getConfig(getState))
        .then(res => extractToken(res.data, dispatch))
        .catch(err => console.error(err))
};

const extractToken = (data, dispatch) => {
    const {token, claims} = auth.extractTokenAndClaims(data);
    dispatch(setToken(token, true));
    dispatch(setClaims(claims));
    dispatch(setAuthState(true));
};

// --------  Senders ----------- //
/**
 * Sets the requestSending state, which displays a loading indicator during requests
 * @param  {boolean} sending The new state the app should have
 * @return {object}          Formatted action for the reducer to handle
 */
export const sendingRequest = sending => ({type: SENDING_REQUEST, sending});
export const setClaims = claims => ({type: SET_CLAIMS, claims});
export const setToken = (token, rememberMe) => ({type: SET_TOKEN, token, rememberMe});
/**
 * Sets the authentication state of the application
 * @param {boolean} newState True means a userId is logged in, false means no userId is logged in
 */
export const setAuthState = newState => ({type: SET_AUTH, newState});




// WEBPACK FOOTER //
// ./src/js/reducers/auth.js